import { storage } from 'BASE/common/util/util.storage';
import Constant from 'BASE/common/lotteryConstant';

let _getPromise = null;
export async function get() {
    let menu = storage.temp.get(storage.keys.MENU_GAME);
    if (menu) {
        return menu;
    }

    if (!_getPromise) {
        _getPromise = new Promise(async resolve => {
            menu = {};
            let data = await $.post('/api/Menu/Game');
            data.forEach(m => {
                let ids = _getIds(m);
                m.gameIds = ids.filter((id, i) => ids.indexOf(id) == i);
                menu[m.Key] = m;
            });
            storage.temp.set(storage.keys.MENU_GAME, menu);
            resolve(menu);
            _getPromise = null;
        });
    }

    return _getPromise;
}

export async function getBetTypeConfig() {
    let config = storage.temp.get(storage.keys.MERCHANT_BETTYPE);
    if (!config) {
        config = {};
        config = await $.post('/api/Menu/BetTypeConfig');

        storage.temp.set(storage.keys.MERCHANT_BETTYPE, config);
    }
    return config;
}

export function mergeInfo(menu, objs, extObjs) {
    if (!menu || objs.some(o => !o)) {
        return {};
    }

    return _mergeInfo(menu.Items, objs, extObjs);
}

function _mergeInfo(items, objs, extObjs) {
    let res = [];
    for (let item of items) {
        if (item.Items) {
            res.push({
                Name: item.Name,
                Items: _mergeInfo(item.Items, objs, extObjs),
                Index: item.Index || 0
            });
        } else {
            let infos = [];
            if (item.GameType != Constant.GameType.LOTTERY && item.GameType != Constant.GameType.VRLottery) {
                if (!item.Name && typeof(extObjs) !== "undefined" ) {
                    infos = extObjs.map(o => o[item.GameType]);
                }
            }
            else {
                infos = objs.map(o => o[item.Id]);
            }
            if (infos.every(i => i)) {
                res.push(Object.assign({}, item, ...infos));
            }
        }
    }
    return res;
}

function _getIds(menu, res) {
    res = res || [];
    for (let item of menu.Items) {
        if (item.Items) {
            res = _getIds(item, res);
        } else {
            res.push(item.Id);
        }
    }
    return res;
}

export function flatten(arr, res) {
    res = res || [];
    $.each(arr, function (index, item) {
        if (item.Items) {
            res = flatten(item.Items, res);
        } else {
            res.push(item);
        }
    });
    return res;
}